import { render } from "./DeleteModal.vue?vue&type=template&id=7dcffd5b&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=7dcffd5b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7dcffd5b"

export default script